module.exports = "/assets/data/9749e0bc6cca45ffcc67e060b7d52bbf-NE31.data.json";